export default "__VITE_ASSET__6b76a57e__"